export default __webpack_public_path__ + "static/8-79eeb53c16ee1f385134d88a5ac956eb.jpg";